import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import ThankYouImage from "../../assets/images/thank-you.png";
import { useScreenContext } from "../Layout";
import { getRecommendations } from "../../lib/data";

function ThankYou() {
  const { t } = useTranslation();
  const [screenData, setScreenData] = useScreenContext();

  useEffect(() => {
    setScreenData({
      ...screenData,
      submitLabel: false,
      nextPath: "book-suggestion/1",
      progress: 63,
    });

    getRecommendations(screenData.userPreferences.topics)
      .then((response) => response.json())
      .then((response) => {
        const normalizedData = response.data.map((book: any) => ({
          id: book.id,
          title: book.title.split(" - ")[0],
          coverImage: book.large_image_url,
          thumImage: book.thumb_image_url,
          author: book.author,
        }));

        normalizedData.forEach((book: any) => {
          const img = new Image();
          img.src = book.coverImage;
        });

        setScreenData({
          ...screenData,
          submitLabel: t("layout.cta_continue"),
          nextPath: "book-suggestion/1",
          progress: 63,
          bookRecommendations: normalizedData,
        });
      });
  }, []);

  return (
    <div>
      <h1 className="mx-5 mb-4 mt-5 text-2xl font-bold tracking-tight text-gray-900 dark:text-white md:text-4xl">
        {t("thank_you.headline.part_1")}
      </h1>
      <h1 className="mx-5 mb-4 mt-5 text-2xl font-bold tracking-tight text-gray-900 dark:text-white md:text-4xl">
        {t("thank_you.headline.part_2")}
      </h1>
      <img
        className="px-10"
        alt="Chart showing your progress"
        src={ThankYouImage}
      />
    </div>
  );
}

export default ThankYou;
